<template>
  <div style="width: 100%; height: 100%">
    <iframe :src="detail.path" style="width: 100%; height: 100%" v-if="detail && detail.path" />
  </div>
</template>

<script>
import { Toast } from 'vant'
import { mapState } from 'vuex'
import md5 from '../components/md5'
export default {
  computed: {
    ...mapState(['isLogin']),
  },
  data() {
    return {
      id: '', // 当前活动id
      shareId: '', // 分享id
      vcardUrl: '',
      vcardData: {
        name: '',
      },

      detail: {},
    }
  },
  methods: {
    async init() {
      Toast.loading({
        duration: 0,
        message: '刷新加载中...',
        forbidClick: true,
      })
      if (this.$route.query.codes) {
        this.codes = decodeURIComponent(this.$route.query.codes) // 分享链接时存储的code
        await this.getCodeParams()
      } else {
        this.id = this.$route.query.id || this.$route.query.activityId
        this.shareId = this.$route.query.shareId
        this.vcardUrl = this.$route.query.vcardUrl
          ? this.$route.query.vcardUrl
          : ''
      }
      await this.getData()
      this.getVcard()
      this.readyShare()
      this.getWxcode()
    },
    // 获取活动详情数据
    getData() {
      console.log('------------')
      const timestamp = new Date().getTime()
      const sign = md5.hexMD5(`${this.id}${timestamp}!_activity_info_!`)
      return this.$http
          .get(
            `aocampaign/openapi/residentActivity/logout/info/${this.id}?sign=${sign}&timestamp=${timestamp}&shareId=${this.shareId}`
          )
          .then((res) => {
            this.detail = res.data
          })
    },
    readyShare() {
      window.wx.ready(async () => {
        // const shareUrl = encodeURIComponent(`https://dev-wxcp.nextxx.cn/campaign/#/?id=${this.id}`)
        const shareUrl = `${location.origin}${location.pathname}#/residentActivityDetail?activityId=${this.id}&shareId=${this.shareId}&vcardUrl=${this.vcardUrl}`
        //需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareAppMessage({
          title: this.detail.activityName, // 分享标题
          desc: this.detail.activityDescription, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detail.publicityImage, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        window.wx.onMenuShareTimeline({
          title: this.detail.activityName, // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detail.publicityImage, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        Toast.clear()
      })
    },
    async getWxcode() {
      this.url = await this.$share.getPosterNew({
        id: this.id,
        shareId: this.shareId,
      })
    },
    getVcard() {
      this.$http
        .get(
          `aocampaign/openapi/activity/card/${this.id}?shareId=${this.shareId || ''}`
        )
        .then((res) => {
          if (res.data) {
            this.vcardData = res.data
            console.log(22, this.vcardData)
          } else {
            this.vcardData = {}
          }
        })
    },
  }
}
</script>